export default __webpack_public_path__ + "static/media/divisa.a8976509.png";